import { Navigate } from "react-router-dom";

import { useDeskOrgLevel } from "./level";
import { DeskAccessGate } from "./DeskAccessGate";
import { surfacesFor, type SurfaceKey } from "./surfaces";

/**
 * A surface the level does not have redirects home rather than rendering a
 * page of nothing. The server already refuses the data; this keeps the URL
 * honest too.
 */
export function DeskSurfaceGuard({
  surface,
  children,
}: {
  surface: SurfaceKey;
  children: React.ReactNode;
}) {
  const level = useDeskOrgLevel();
  const allowed = surfacesFor(level).some((s) => s.key === surface);
  if (!allowed) return <Navigate to="/desk" replace />;
  return <DeskAccessGate>{children}</DeskAccessGate>;
}
